<template>
    <b-modal v-model="modalAberto" size="xl" @hidden="cancelar" button-size="md" hide-footer
        :title="prefix+title">
        <FotoIBPList :prefix="prefix" :id="id"></FotoIBPList>
    </b-modal>
</template>

<script>

import FotoIBPList from '@/modules/patrimonio/fotoibp/FotoIBPList.vue';
import ConfirmMixin from "@/core/mixins/confirm"
import { ListResourceMixin } from "@/core/mixins/resource"

export default {
    name: "ModalFotoIBP",
    components: {
        FotoIBPList,
        
    },
    props: {
        id: Number,
        prefix: {
            tipe: String,
            default: "",
        },
        title: {
            tipe: String,
            default: "Foto do Item Bem Permanente",
        },


    },
    mixins: [ConfirmMixin, ListResourceMixin],
    data() {
        return {
            modalAberto: true,
        }
    },
    methods: {
        cancelar() {
            this.$emit('fecharModal');
        },

    }
}

</script>